import React from 'react';
import {Button, Card, CardContent, Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import { functions } from 'constantes/functions';
import { Visibility } from '@mui/icons-material';

const PersonaJuridica = ({datosGeneralesDeSolicitud, obtenerDocumentoAdjunto}) => {
  const classes = styles();

  const {cuiRepresentante, nombreComercial, razonSocial, notarioConstitucion, nroConstitucion, nroInscripcionEscriConst, folioConstitucion, libroConstitucion, nombreRepLegal, nroFolioReplegal, nroLibroRepLegal, nroRegRepLegal, fechaEscrituraConst, fechaVigenciaRepLegal} = datosGeneralesDeSolicitud?.solicitudPersonaJuridica[0]

  return (
    <Card className={classes.root}>
        <CardContent>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <TituloConIcono title={"Datos de persona jurídica"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Denominación o razón social:'} label={razonSocial || ""}/>
              <ElementoDelCard title={'Nombre comercial:'} label={nombreComercial || ""}/>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Datos de escritura de constitución de sociedad"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Número:'} label={nroConstitucion || ""}/>
              <ElementoDelCard title={'Fecha de escritura'} label={functions.FormatearFecha( fechaEscrituraConst || "") || ""}/>
              <ElementoDelCard title={'Nombre de notario o autorizante:'} label={notarioConstitucion || ""}/>
              <ElementoDelCard title={'Número de inscripción:'} label={nroInscripcionEscriConst || ""}/>
              <ElementoDelCard title={'Folio:'} label={folioConstitucion}/>
              <ElementoDelCard title={'Libro:'} label={libroConstitucion}/>
              <Grid item xs={12}>
            </Grid>
            </Grid>

            <Grid item xs={12}>
              <TituloConIcono title={"Datos del representante legal"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'CUI del DPI:'} label={cuiRepresentante || ""}/>
              <ElementoDelCard title={'Nombre del representante legal:'} label={nombreRepLegal || ""}/>
              <ElementoDelCard title={'Fecha de vigencia hasta'} label={functions.FormatearFecha( fechaVigenciaRepLegal || "") || ""}/>
              <ElementoDelCard title={'Folio:'} label={nroFolioReplegal || ""}/>
              <ElementoDelCard title={'Libro:'} label={nroLibroRepLegal || ""}/>
              <ElementoDelCard title={'Registro:'} label={nroRegRepLegal || ""}/>
            </Grid>
          </Grid>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 2, nombre: "personaJuridica"}, "constitucionPersonaJuridica")} size="large">
                <Visibility />
                Ver constitución de sociedad
              </Button>
            </Grid>
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 2, nombre: "personaJuridica"}, "nombramientoPersonaJuridica")} size="large">
                <Visibility />
                Ver inscripción de nombramiento
              </Button>
            </Grid>
          </Grid>
        </CardContent>
    </Card>
  );
}

export default PersonaJuridica;